angular.module('unergie.main')
.controller('urgentCallsN1Ctrl', ($scope, $state, AlertManager, DataAccessVariables,
    ReferencesService, BoFeaturesService, ErrorCatcher, ApiAdmin, JiraConstants,
    DataAccessSearch, FilterMapping, AuthService, AdminComments, TableGeneratorService, ApiUser, JiraService) => {
    $scope.contract_status_mapping = FilterMapping.contractStatus

    $scope.issues = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'ID', mode: 'search_wildcard', length: 9 },
            'account.customer_id': { label: 'Compte', mode: 'search_wildcard' },
            'id_prm': { label: 'PRM', mode: 'search_operator', length: 14 },
            'reason': { label: 'Motif', mode: 'filter_only' },
            'affectationUser': { label: 'Responsable', mode: 'filter_only' },
            'fullname': { label: 'Nom', mode: 'search_wildcard' },
            'mail': { label: 'Email', mode: 'search_wildcard' },
            'phone': { label: 'Teléphone', mode: 'search_wildcard' },
            'provider_offer': { label: 'Offre', mode: 'search_wildcard' },
        },
    }

    const transformData = function (data) {
        const contractsElec = _.groupBy(data, 'id')
        return _.map(_.filter($scope.jiraIssues, (jiraIssue) => contractsElec[jiraIssue.fields.idContract]), (jiraIssue) => {
            const contractElec = contractsElec[jiraIssue.fields.idContract][0]
            return {
                jiraId: jiraIssue.id,
                id: contractElec.id,
                key: jiraIssue.key,
                id_prm: contractElec.id_prm,
                reason: JiraConstants.epics[jiraIssue.fields.epicLink],
                affectationUser: jiraIssue.fields.assigneeBO,
                fullname: contractElec.fullname,
                mail: contractElec.mail,
                phone: contractElec.phone,
                provider_offer: contractElec.provider_offer,
                account: contractElec.account,
            }
        })
    }
    const refresh = () => {
        $scope.refreshing = true

        const params = {}
        params.filter = () => ({
            issuetype: 'Task',
            status: '!10594',
            epicLink: 'SN2-934',
        })
        return JiraService.getData(params, 'support,exploit', 'idContract').$promise.then((response) => {
            $scope.jiraIssues = response.results.issues
            TableGeneratorService.getTable($scope.issues, 'contractdrafts', 'account,prm', transformData, {
                in: [`id=${_.map($scope.jiraIssues, `fields.idContract`).join(',')}`],
            })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.refresh = refresh
    $scope.refresh()

    ReferencesService.getRef('contractStatus').then((contractStatusMapping) => {
        const filteredContractStatusMapping = angular.fromJson(angular.toJson(contractStatusMapping))
        $scope.contractMapping = _.map(filteredContractStatusMapping, (value, key) => ({ id: key, label: _.get(value, '[0].label_fr', key) }))
    })

    $scope.isActive = (state) =>
        $state.is(state)

    $scope.assignToUser = (jiraIssue) => {
        jiraIssue.affectingUser = true
        const payload = {
            assigneeBO: AuthService.getAuth().user,
        }
        return ApiAdmin.updateJiraIssue({ idIssue: jiraIssue.key, projectKey: 'support' }, payload).$promise.then(() => {
            // Save data
            refresh()
            AlertManager.success('Issue JIRA mis a jour')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            jiraIssue.affectingUser = false
        })
    }

    $scope.resolveTicket = (payload) => {
        payload.resolvingIssue = true
        const idProject = payload.key && payload.key.split('-')[0]
        return ApiAdmin.updateJiraIssueStatus({ idIssue: payload.key, idStatus: '51', idProject }, {}).$promise.then(() => {
            // Save data
            refresh()
            AdminComments.addComment({ object: payload.id, comment: '[Suivi commande] Appel client pour finalisation de commande' }).$promise.catch(ErrorCatcher)
            AlertManager.success('Issue JIRA mis a jour')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payload.resolvingIssue = false
        })
    }
})
